export const SAVE_OFFERS = 'SAVE_OFFERS'